import { Card } from "@/src/components/cards";
import SearchKeyHighliter from "@/src/components/seachkeyHighlighter";
import { User } from "@/src/data/allTypes";
import { getUserShortName } from "@/src/utils/utils";
import { UserAvatar } from "./userAvatar";
import { InfoGrid } from "@/src/components/infoGrid";

export function UserCard({
  user,
  searchKey,
  onClick,
  onDelete,
}: {
  user: User;
  searchKey?: string | null | undefined;
  onClick: () => void;
  onDelete?: () => void;
}) {
  return (
    <Card
      color="simple"
      className="tcenter"
      onClick={async () => {
        await onClick();
      }}
      onDelete={async () => {
        onDelete?.();
      }}
    >
      <div className="left">
        <UserAvatar user={user} size={40}></UserAvatar>
      </div>
      <div className="bold blue-color">
        <SearchKeyHighliter searchKey={searchKey}>
          {getUserShortName(user)}
        </SearchKeyHighliter>
      </div>
      <div className="center">
        <div className={`br2 bold p10 m5 ${user.role?.color}ish`}>
          {user.role?.name}
        </div>
      </div>

      <div className="c1 gap10 tleft mtop10">
        <InfoGrid
          name="Service"
          value={
            <div className="normal">
              {user.service?.name} - {user.service?.hospital?.name}
            </div>
          }
        ></InfoGrid>

        <InfoGrid
          name="Spécialité"
          value={<div className="normal">{user.speciality?.name}</div>}
        ></InfoGrid>

        <InfoGrid
          name="Email"
          value={
            <div className="normal">
              <SearchKeyHighliter searchKey={searchKey}>
                {user.email}
              </SearchKeyHighliter>
            </div>
          }
        ></InfoGrid>
      </div>
    </Card>
  );
}
